import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'
import IdentitiRoutes from './modules/identiti2/routes.js'
import ReportRoutes from './modules/Reports/routes.js'
import sizeScalesRoutes from './modules/sizeScales/routes.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: IdentitiRoutes.concat(ReportRoutes, sizeScalesRoutes, [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/companies',
      name: 'CompanyIndex',
      component: () => import(/* webpackChunName: "CompanyIndex" */ './views/companies/template/index.vue')
    },
    {
      path: '/companyProfile',
      name: 'companyProfile',
      component: () => import(/* webpackChunName: "companyProfile" */ './views/companies/template/companyProfile.vue')
    },
    {
      path: '/erpProfile',
      name: 'erpProfile',
      component: () => import(/* webpackChunName: "erpProfile" */ './views/companies/template/erpProfile.vue')
    },
    {
      path: '/dataSet',
      name: 'dataSetIndex',
      component: () => import(/* webpackChunName: "dataSetIndex"*/ './views/dataSets/template/index.vue')
    },

    {
      path: '/company/add',
      name: 'CompanyAdd',
      component: () => import(/* webpackChunName: "CompanyAdd" */ './views/companies/template/add.vue')
    },
    {
      path: '/company/edit',
      name: 'CompanyEdit',
      component: () => import(/* webpackChunName: "CompanyEdit" */ './views/companies/template/edit.vue')
    },
    {
      path: '/company/view',
      name: 'CompanyView',
      component: () => import(/* webpackChunName: "CompanyView" */ './views/companies/template/view.vue')
    }
  ])

})

export default router;
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register', '/resetPassword', '/join', '/signup', '/autoLogin', "/logincompany"];
  const authRequired = !publicPages.includes(to.path);
  const host = window.location.host;
  const parts = host.split('.');
  if (host.indexOf('localhost') >= 0) {
    store.commit('SET_DOMAIN_HOST', 'localhost')
  } else {
    store.commit('SET_DOMAIN_HOST', parts[0])
  }
  const $storage = (localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))

  const loggedIn = $storage ? JSON.parse($storage) : null
  if (loggedIn && to.path != '/logout') {
    store.commit('SET_USER_INFO', loggedIn.data.User)
    store.commit('SET_ADMINISTRATOR', loggedIn.data.User.roleType == 'AD')
  }
  if (authRequired && !loggedIn) {
    if (to.fullPath.indexOf('logout')) {
      return next('/logincompany');
    } else {
      return next('/logincompany' + querystring.stringify(to.query));
      //return next('/login?redirectUrl='+to.fullPath);
    }
  }
  next();
})

